import {Component, inject, input, model, OnInit} from '@angular/core';
import {Button} from 'primeng/button';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {ButtonGroupModule} from 'primeng/buttongroup';
import {SelectButtonModule} from 'primeng/selectbutton';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Widget} from '../../models/dashboard';
import { CommonModule } from '@angular/common';
import { ResizableModule } from 'angular-resizable-element';
import { DashboardService } from '../../services/dashboard.service';

@Component({
    selector: 'app-widget-options',
    standalone: true,
    imports: [
        Button,
        ToggleButtonModule,
        ButtonGroupModule,
        SelectButtonModule,
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        ResizableModule 
    ],
    templateUrl: './widget-options.component.html',
    styleUrl: './widget-options.component.css'
})
export class WidgetOptionsComponent implements  OnInit{
  // ModelImport to access the showOptions of the WidgetComponent;  <app-widget-option [(showOption..
  showOptions = model<boolean>(false);
  data = input.required<Widget>();

  dashboardService = inject(DashboardService);

  widthOptions: any[] = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 }
  ];
  heightOptions: any[] = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6', value: 6 }
  ];


  ngOnInit(): void {

  }

}
